import { render } from "./ParallaxText.vue?vue&type=template&id=015cca64&scoped=true"
import script from "./ParallaxText.vue?vue&type=script&lang=js"
export * from "./ParallaxText.vue?vue&type=script&lang=js"

import "./ParallaxText.vue?vue&type=style&index=0&id=015cca64&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015cca64"]])

export default __exports__